/**
 * Export Detail Table to CSV
 */

import { COLUMN_MODES, GALLONS_PER_ACRE_FOOT } from "../constants";
import { computePctPermit } from "../utils";
import { downloadCSV } from "./downloadCSV";

/**
 * Export detail table data to CSV
 * @param {Array} filteredRows - Filtered data rows
 * @param {Object} totals - Calculated totals
 * @param {string} columnMode - Column display mode
 */
export const exportDetailTable = (filteredRows, totals, columnMode) => {
  const headers =
    columnMode === COLUMN_MODES.compact
      ? [
          "File No",
          "State #",
          "Well Name",
          "Agg System",
          "Year",
          "Aquifer",
          "Hist. Permit (ac-ft)",
          "Oper. Permit (ac-ft)",
          "Total Permit (ac-ft)",
          "YTD (gal)",
          "Remaining (gal)",
          "YTD (ac-ft)",
          "Remaining (ac-ft)",
          "% Permit",
        ]
      : [
          "File No",
          "State #",
          "Well Name",
          "Agg System",
          "Year",
          "Aquifer",
          "Hist. Permit (ac-ft)",
          "Oper. Permit (ac-ft)",
          "Total Permit (ac-ft)",
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
          "YTD (gal)",
          "Remaining (gal)",
          "YTD (ac-ft)",
          "Remaining (ac-ft)",
          "% Permit",
        ];

  const csvRows = [headers];

  filteredRows.forEach((row) => {
    const remainingGal =
      (row.h_permit_value_gal || 0) +
      (row.o_permit_value_gal || 0) -
      (row.ytd_gal || 0);
    const remainingAf = remainingGal / GALLONS_PER_ACRE_FOOT;
    const pctPermit =
      row.h_permit_value_gal + row.o_permit_value_gal > 0
        ? row.ytd_gal / (row.h_permit_value_gal + row.o_permit_value_gal)
        : 0;

    const baseRow = [
      row.cuwcd_well_number || "",
      row.state_well_number || "",
      row.well_name || "",
      row.agg_system_name || "",
      row.report_year,
      row.aquifer_name || "",
      row.h_permit_af,
      row.o_permit_af,
      row.total_permit_af,
    ];

    if (columnMode === COLUMN_MODES.full) {
      baseRow.push(
        row.jan,
        row.feb,
        row.mar,
        row.apr,
        row.may,
        row.jun,
        row.jul,
        row.aug,
        row.sep,
        row.oct,
        row.nov,
        row.dec
      );
    }

    baseRow.push(row.ytd_gal, remainingGal, row.ytd_af, remainingAf, pctPermit);

    csvRows.push(baseRow);
  });

  // Add totals row
  // Permits are deduplicated by system+year (passed in from component)
  const totalRemainingGal =
    totals.h_permit_value_gal + totals.o_permit_value_gal - totals.ytd_gal;
  const totalRemainingAf = totalRemainingGal / GALLONS_PER_ACRE_FOOT;
  const totalPctPermit = computePctPermit(totals);

  const totalsRow = [
    "TOTAL",
    "",
    "",
    "",
    "",
    "",
    totals.h_permit_af,
    totals.o_permit_af,
    totals.total_permit_af,
  ];

  if (columnMode === COLUMN_MODES.full) {
    totalsRow.push(
      totals.jan,
      totals.feb,
      totals.mar,
      totals.apr,
      totals.may,
      totals.jun,
      totals.jul,
      totals.aug,
      totals.sep,
      totals.oct,
      totals.nov,
      totals.dec
    );
  }

  totalsRow.push(
    totals.ytd_gal,
    totalRemainingGal,
    totals.ytd_af,
    totalRemainingAf,
    totalPctPermit
  );

  csvRows.push(totalsRow);

  downloadCSV(csvRows, "well-detail-data.csv");
};
